import React, {useEffect, useState} from 'react';
import '../css/navBar.css';
import '../css/registro.css';
import FormInput from './FormInput';
import EncabezadoAdmin from './EncabezadoAdmin';
import BtnGuardarEdit from './BtnGuardarEdit';
import { handleError, toastError, toastSuccess } from '../funciones';
import axios from '../axiosConfig'; 
import search from '../assets/search.png';
import ModalPerfil from './ModalPerfil';
import DeseaCancelar from './DeseaCancelar';
import ModalExisteCuit from './ModalExisteCuit'; 
import { ContainerAdmin } from './ContainerAdmin';
import { ModalCambiarUnion } from './ModalCambiarUnion';
 

function EmpresasAdmin(){
    const [empresas, setEmpresas] = useState([]);
    const [empresasCopia, setEmpresasCopia] = useState([]);
    const [perfil, setPerfil]=useState({rubros:[], productosOfrecidos:[], productosDemandados:[], nombre:''}); 
    const [tipoEvaluar, setTipoEvaluar]=useState("0"); 
    const [tipoMora, setTipoMora]=useState("0"); 
    const [union, setUnion]=useState("0"); 
    const [idEmpresaEvaluar, setIdEmpresaEvaluar]=useState(""); 
    
     
    useEffect(() => { 
        axios
        .get(process.env.REACT_APP_URL + 'empresa/todasLasEmpresas')
        .then(function (response) { 
            setEmpresasCopia(response.data); 
            setEmpresas(response.data);
        })
        .catch(function (error) {
            toastError(handleError(error))
        });
        
    },[]) 
    
    function modificarMora(empresaId, tipo){
        const params = {
            params : {empresaId: empresaId,
            tipoMora: tipo,
            }
        }
        axios
        .put(process.env.REACT_APP_URL + "empresa/modificarMora", null, params)
        .then((res) => {
            //if(!props.esModificar) 
            cambiarEmpresa(empresaId, tipo, 0);
            if(tipo)
                toastSuccess("Mora agregada")
            else
                toastSuccess("Mora removida")
 
        })
        .catch(function (error) {
            toastError(handleError(error))
        })
            
    } 
    function cambiarEmpresa(idEmpresa, valor, tipoModif, numeroUnion){
        //tipoModif -- 0 = modificarMora, 1 = evaluarUsuario, 2 = cambiarUnion
        
        
        setEmpresas(empresas.map((elem) => {
            if (elem.id.localeCompare(idEmpresa) === 0 ) 
                if(tipoModif === 0)
                    elem.estaEnMora = valor;
                else if(tipoModif === 1)
                    elem.estaAprobado = valor;
                else if(tipoModif === 2){
                    elem.union = valor;
                    elem.numeroUnion = numeroUnion;
                }
            return elem;
        }));            
        setEmpresasCopia(empresasCopia.map((elem) => {
            if (elem.id.localeCompare(idEmpresa) === 0 ) 
                if(tipoModif === 0)
                    elem.estaEnMora = valor;
                else if(tipoModif === 1)
                    elem.estaAprobado = valor;
                else if(tipoModif === 2){
                    elem.union = valor;
                    elem.numeroUnion = numeroUnion;
                }
            return elem;
        }));       
        
            /*setEmpresasEvaluar(empresasEvaluar.map((elem) => {
                if (elem.id.localeCompare(idEmpresa) === 0 ) 
                    elem.estaAprobado = valor;
                return elem;
            })); */           
        
    }
       
     

    function evaluarUsuario(empresaId, tipo){
        const params = {
            params : 
            {empresaId: empresaId,
                tipo: tipo,
            }
        }
        axios
        .put(process.env.REACT_APP_URL + "empresa/evaluarUsuario", null, params)
        .then((res) => {
            //if(!props.esModificar) 
            cambiarEmpresa(empresaId, tipo, 1);
            if(tipo)
                toastSuccess("Usuario aprobado")
            else
                toastSuccess("Usuario desaprobado")
 
        })
        .catch(function (error) {
            toastError(handleError(error))

        })
            
    }
    function mostrarEmpresa(elem){ 
        return (tipoEvaluar === "0" || (tipoEvaluar === "1" && elem.estaAprobado === null)
        || (tipoEvaluar === "2" && elem.estaAprobado)|| (tipoEvaluar === "3" && !elem.estaAprobado))
        && (tipoMora === "0" || (tipoMora === "1" && elem.estaEnMora)
        || (tipoMora === "2" && !elem.estaEnMora)) && (union === "0" || union == elem.numeroUnion )
    }
    useEffect(() => {
        document.getElementById("buscarText").addEventListener("keyup", function() {
            filtrarNombre();
        });
    },[empresasCopia]) 
    
    function filtrarNombre(){
         
        const filtro = document.getElementById("buscarText").value;
         if(filtro.localeCompare("") !== 0){
             
            setEmpresas([])
            empresasCopia.map(function(elem){
                if(elem.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")
                    .includes(filtro.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""))){
                    
                        setEmpresas(empresas => [...empresas, elem]) 
                         
                }
            }); 
             
        }
        else{
            setEmpresas(empresasCopia)
        }
    }
    /*function sinEmpresas(index){
        console.log(document.getElementById("empresas").childNodes.length )
        return index === empresas.length - 1 && document.getElementById("empresas").childNodes.length === 0;
    }*/
    /*function crearEvento(){
                
        if(!document.getElementById("nombreEvento").value){
            toastError("Debe completar el nombre del evento");
            document.getElementById("nombreEvento").classList.add("texBoxError");
        }else if(horaInicio >= horaFin){
            toastError("La hora de fin debe ser mayor a la hora de inicio");
        }else if(!document.getElementById("uniones").value){
            toastError("Debe seleccionar un tipo de invitado permitido");
            document.getElementById("uniones").classList.add("texBoxError");
        }
        else{
            var permitirPasar = true;
            if(esRondaNegocios){
                if(!document.getElementById("duracionReunion").value){
                    document.getElementById("duracionReunion").classList.add("texBoxError");
                    toastError("Al ser una ronda de negocios debe completar la duración de la reunión");
                    permitirPasar = false;
                }
                if(!document.getElementById("duracionEntreReunion").value){
                    document.getElementById("duracionEntreReunion").classList.add("texBoxError");
                    toastError("Al ser una ronda de negocios debe completar la duración entre reuniones");
                    permitirPasar = false;
                }
                if(!document.getElementById("cantMesas").value){
                    document.getElementById("cantMesas").classList.add("texBoxError");
                    toastError("Al ser una ronda de negocios debe completar la cantidad de mesas");
                    permitirPasar = false;
                }
            }
            if(poseeBreak){
                if(horaInicioBreak >= horaFinBreak){
                    toastError("La hora de fin del break debe ser mayor a la hora de inicio del break");
                    permitirPasar = false;
                }
                else if(horaInicioBreak < horaInicio || horaFin < horaFinBreak ){
                    toastError("El break debe estar dentro del horario del evento");
                    
                    permitirPasar = false;
                }
                    

            }
            if(tipoCupo === "Ingrese su cupo" && !document.getElementById("cupo").value){
                document.getElementById("cupo").classList.add("texBoxError");
                toastError("Debe ingresar el cupo del evento");
                permitirPasar = false;
            }
            if(permitirPasar){
                var cupo = -1
                if(tipoCupo === "Ingrese su cupo"){
                    cupo = document.getElementById("cupo").value;
                }
                else if(tipoCupo === "Doble de la cantidad de mesas"){
                    cupo = parseInt(document.getElementById("cantMesas").value) * 2;
                }
                const params = {
                    nombre: document.getElementById("nombreEvento").value,
                    fecha: fecha,
                    horaInicio: horaInicio,
                    horaFin: horaFin,
                    cupoMaximo: cupo,
                    unionLaboral: document.getElementById("uniones").value,
                    duracionReunion: duracion,
                    duracionEntreReuniones: duracionEntreReunion,
                    permiteReuniones: esRondaNegocios,
                    mostrarReuniones: mostrarReuniones,
                    generarTurnos: generarReuniones
                }
                if(poseeBreak){
                    params.horaInicioBreak = horaInicioBreak;
                    params.horaFinBreak = horaFinBreak
                }
                axios
                .post(process.env.REACT_APP_URL + 'evento?cantidadDeMesas=' + cantMesas, params)
                .then((res) => {
                    
                    toastSuccess("Evento creado")
                })
                .catch(function (error) {
                    toastError(handleError(error))
                })
            }
        }
    }*/
    return( 
         
        <>  
        <ContainerAdmin mainContent={
            <>
            <EncabezadoAdmin subtitulo={'Apruebe o desapruebe empresas para que puedan usar o no el sistema'} titulo={'Aprobar Empresas'}/>
            <div id="datosEmpresa">
                <div className='row'>
                     <div  id="botonBuscarCompleto"  className= 'offset-sm-1 col-12 col-sm-10 pb-3 pb-sm-0 '>
                    
                    <div className='rounded-4 bg-white ps-1 centrarContainer  border btn-buscar'>
                        <img className='mx-2 mobile-white' src={search} alt=""/>
                         <input id='buscarText'class="ps-0 form-control form-normal rounded-4 border-0 bold-botones botonBuscar d-inline-block " 
                        type="text" placeholder="Buscar" aria-label="Buscar"/> 
                            
                    </div>  
                            
                    </div>
                </div>  
                <div className='row mt-4'>
                    <FormInput id={"tipoEvaluar"} text={"Tipo de evaluación"} className={"col-md col-12 offset-sm-1 col-sm-10 w-lista-100"} 
                    idSeccion={7} setValue={setTipoEvaluar} items={["Todas", "A evaluar", "Aprobadas", "Desaprobadas"]}/> 
                    <FormInput id={"tipoMora"} text={"Tipo de mora"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0 w-lista-100"} 
                    idSeccion={7} setValue={setTipoMora} items={["Todas", "Con mora", "Sin mora"]}/> 
                    <FormInput id={"uniones"} text={"Tipo de unión"} className={"col-md col-12 offset-sm-1 col-sm-10 offset-md-0 mb-3 mb-sm-0"} 
                    mostrarTodas={true} idSeccion={0} setValue={setUnion}/>
                    <div className='col-md-1'></div>
                </div>
                <div className='container-fluid bg-white rounded-4 textoTablas tablaEmpresaAdmin position-relative mx-0 mx-sm-auto ' id='tabla' >
                <div className='row encabezadosTablas py-3 px-sm-3 px-0 bordeTablas align-items-center ocultarMobile'>
                        <>
                            <div className='col-4 text-center '>
                                <div className='mostrarNombreEmpresaMobile d-none'>Empresa</div>
                                <div className='ocultarNombreEmpresaMobile'>Nombre de la empresa</div>
                                
                            </div>
                            <div className='col text-center'>
                                Ver Perfil
                            </div>
                            <div className='col text-center'>
                                Mora
                            </div>
                            <div className='col text-center'>
                                Aprobar empresa
                            </div>
                            <div className='col text-center'>
                                Modificar Unión
                            </div>
                        </>
                   
                    
                </div>
                {/*<div className='alturaScrollTabla  scrollArea px-3 px-sm-0 '>*/}
                <div id="empresas">
                {empresas.length !== 0?
                        
                    empresas.map(function(elem, i){
                    return(                        
                        mostrarEmpresa(elem)?   
                        <div id={'idElem' + i} className='row py-3 px-0 px-sm-3 bordeTablas align-items-center mx-0 marginTabla' >
                            
                                <div className='text-center col-sm-4 col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                    {elem.nombre}
                                </div>
                                
                               
                                <div className='col text-center px-0'>
                                    
                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal" 
                                    data-bs-target="#modalPerfil" onClick={()=>{setPerfil(elem); setIdEmpresaEvaluar(elem.id)}}>Ver Perfil</button>
                                                      
                                </div>
                                <div className='col text-center px-0'>
                               
                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " 
                                    onClick={()=>modificarMora(elem.id, !elem.estaEnMora)}>
                                        {elem.estaEnMora? 'Remover Mora':'Agregar Mora'}
                                    </button>
                                 
                                                      
                                </div><div className='col text-center px-0'>
                                    {!elem.estaAprobado || elem.estaAprobado === null? 
                                        <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas w-btn-aprobar" 
                                        onClick={()=>evaluarUsuario(elem.id, true)}> Aprobar
                                        </button>
                                    :
                                        <></>
                                    }
                                    {elem.estaAprobado || elem.estaAprobado === null? 
                                        <button class={"btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas w-btn-aprobar"
                                            + (elem.estaAprobado === null? " mt-2" : "") } 
                                        onClick={()=>setIdEmpresaEvaluar(elem.id)}  data-bs-toggle="modal" 
                                        data-bs-target="#desaprobarUsuario"> Desaprobar
                                        </button>
                                    :
                                        <></>
                                    } 
                                                      
                                </div>
                                <div className='col text-center px-0'>
                                    
                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal" 
                                    data-bs-target="#modalCambiarUnion" onClick={()=>setPerfil(elem)}>Modificar Unión</button>
                                                      
                                </div>
                        </div>
                        
                        :
                        <></>
                    )
                    }) 
                :
                    <>
                        <p className='text-center mt-4'>No se encontraron empresas</p>
                    
                    </>
                } 
                </div> 
                </div>
                </div>
                </>
        }/>
                {/*</div>*/}  
                <ModalPerfil perfil={perfil}  modificarMora={modificarMora} evaluarUsuario={evaluarUsuario} 
                setPerfil={setPerfil} esAdmin={true}/>
                <ModalExisteCuit />
                <ModalCambiarUnion perfil={perfil} cambiarEmpresa={cambiarEmpresa}/>
                <DeseaCancelar funcionAdmin={()=>evaluarUsuario(idEmpresaEvaluar, false)} id={'desaprobarUsuario'}/>
                
        </>
    );
}

export default EmpresasAdmin;